import { useQuery } from 'react-query';
import getBrands from 'data/requests/getBrands';
import { Brand } from 'model/brand';

const useBrands = () => {
  const { data, isLoading } = useQuery<Brand[]>('brands', getBrands, {
    staleTime: 1000 * 60 * 5,
  });

  return { brands: data || [], isLoading };
};

export default useBrands;
